import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

//Projects
import ProjectsList from '../Projects/ProjectsList';
import { Layout, LayoutPanel  } from 'rc-easyui';
import ApiUtils from "../../helper/ApiUtils";


//const MediaServices = require('azure-arm-mediaservices');
//const msRestAzure = require('ms-rest-azure');
// const msRest = require('ms-rest');
// const azureStorage = require('azure-storage');

// endpoint config
// make sure your URL values end with '/'


class VideoMainView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData:null
        };
    }

    async componentDidMount() {


        let azureMediaServicesClient;
        // msRestAzure.loginWithServicePrincipalSecret(aadClientId, aadSecret, aadTenantId, {
        //     environment: {
        //         activeDirectoryResourceId: armAadAudience,
        //         resourceManagerEndpointUrl: armEndpoint,
        //         activeDirectoryEndpointUrl: aadEndpoint
        //     }
        // }, async function(err, credentials, subscriptions) {
        //     if (err) return console.log(err);
        //     azureMediaServicesClient = new MediaServices(credentials, subscriptionId, armEndpoint, { noRetryPolicy: true });
        //
        //     console.log("connected");
        //
        // });
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        const {listData,subscriptionId,resourceGroupName,accountName,assetName} = this.state;

        // mainContent = <div className="col-12   pb-5"   style={{ backgroundColor:`white`}} >
        //     {projectsListView}
        // </div>;


        let mainView;
        if(listData === null){
            mainView = <div>LOADING</div>
        }else{


            mainView = <Layout className="col-12"  >

            </Layout>;
        }


        return (<div  style={{backgroundColor:'#dfdde0' }} >
           111
        </div>);

    }
}


VideoMainView.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { })(
    withRouter(VideoMainView)
);



// WEBPACK FOOTER //
// ./src/components/video/VideoMainView.js